<div class="dropdown-control regular-10 d-flex justify-center align-items-center" (click)="toggle()" [ngClass]="{'open-dropdown': this.isDropdownOpen}">
  <div class="display-container new-sidebar-icon d-flex justify-center align-items-center fv-item clickable">
    <i phx-icon [phxIcon]="circleQuestion"></i>
  </div>
</div>
<div class="content dropdown">
  <h3 class="heading semi-bold-18" i18n>Help & Support</h3>
  <div class="divider"></div>
  <div class="links-container">
    <div class="link">
      <a class="regular-14" [href]="supportFleet" (click)="toggle()" target="_blank">
        <ng-container i18n>Help Center</ng-container>
      </a>
    </div>
    <div *ngIf="isChatbotEnabled" class="link">
      <ada-chatbot (click)="closeIfOpen()"></ada-chatbot>
    </div>
    <div *ngIf="isProductFeedbackEnabled" class="link">
      <a class="regular-14" target="_blank" (click)="loginAndRedirect($event)" i18n>Product Feedback</a>
    </div>
    <div *ngIf="isUpdateCreditCardEnabled && hasZuoraAccount" class="link">
      <a class="regular-14" [href]="updateCreditCardPageLink" (click)="toggle()" target="_blank">
        <ng-container i18n>Update Payment Information</ng-container>
      </a>
    </div>
  </div>
</div>
